import 'css-chunksrc/client/pages/planzoneParametersPage/timeAllocation/styles.scss';export default {
  "timeAllocation": "_timeAllocation_1bjr2_1",
  "description": "_description_1bjr2_5",
  "boxes": "_boxes_1bjr2_11",
  "box": "_box_1bjr2_11",
  "boxInput": "_boxInput_1bjr2_32"
};